import { cssRule } from 'typestyle';

cssRule('.tb-user-authentication-options .tb-outline-button', {
    width: '100%',
    marginBottom: '5px',
    display: 'block',
});

cssRule('table.tb-user-authentication-options tr', {
    verticalAlign: 'middle',
    textAlign: 'left',
});

cssRule('table.tb-user-authentication-options tr td', {
    paddingBottom: '5px',
});

cssRule('table.tb-user-authentication-options td.tb-button .tb-outline-button', {
    width: '100%',
});

cssRule('table.tb-user-authentication-options td.tb-description', {
    whiteSpace: 'normal',
});

